import { Link } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { Logo } from "@/components/brand/Logo";
import { trackEvent } from "@/lib/umami";

export function Footer() {
  const { t } = useTranslation("landing");

  return (
    <footer className="mx-auto mt-24 max-w-[1200px] px-5 pb-12 md:px-10">
      <div className="flex flex-col gap-10 border-t border-border pt-10 md:flex-row md:justify-between">
        <div className="max-w-[320px]">
          <Logo size={22} />
          <p className="mt-3 text-sm text-muted-foreground">{t("footer.tagline")}</p>
        </div>
        <div className="grid grid-cols-2 gap-12 text-sm sm:grid-cols-3">
          <div className="flex flex-col gap-2.5">
            <span className="font-semibold">{t("footer.product")}</span>
            <Link to="/" hash="how" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.how")}
            </Link>
            <Link to="/" hash="protection" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.protection")}
            </Link>
            <Link to="/" hash="faq" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.faq")}
            </Link>
            <Link
              to="/extension"
              onClick={() => trackEvent("extension_cta_click", { location: "footer" })}
              className="text-muted-foreground hover:text-foreground"
            >
              {t("footer.links.extension")}
            </Link>
          </div>
          <div className="flex flex-col gap-2.5">
            <span className="font-semibold">{t("footer.guides")}</span>
            <Link to="/email-alias" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.emailAlias")}
            </Link>
            <Link to="/catch-all-email" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.catchAll")}
            </Link>
          </div>
          <div className="flex flex-col gap-2.5">
            <span className="font-semibold">{t("footer.account")}</span>
            <Link to="/login" className="text-muted-foreground hover:text-foreground">
              {t("footer.links.login")}
            </Link>
            <Link
              to="/signup"
              onClick={() => trackEvent("signup_cta_click", { location: "footer" })}
              className="text-muted-foreground hover:text-foreground"
            >
              {t("footer.links.signup")}
            </Link>
          </div>
        </div>
      </div>
      <p className="mt-10 text-[13px] text-faint">
        <Trans
          t={t}
          i18nKey="footer.madeBy"
          components={{
            brand: (
              <a
                href="https://holymoly.dev"
                target="_blank"
                rel="noopener"
                className="font-medium text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
              />
            ),
          }}
        />
      </p>
    </footer>
  );
}
